exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2T8-QUSnWwi13Q{background:transparent;height:100%;display:flex;flex-direction:column;padding:32px;min-width:900px}@media only screen and (max-width:750px){._2T8-QUSnWwi13Q{min-width:0;padding:0;height:100vh;height:-webkit-fill-available}}._8erS7cOdcGGKlg{position:absolute;width:100px}@media only screen and (max-width:750px){._8erS7cOdcGGKlg{position:static;margin-bottom:16px}}.FMKLJUZAMVUfoi{display:flex;flex-direction:row}.FMKLJUZAMVUfoi>:last-child{margin:auto}@media only screen and (max-width:750px){.FMKLJUZAMVUfoi{flex-direction:column;align-items:center;padding:48px 16px 16px;background-color:#f4f5f7}}._3xDD6kI3h9zVPQ{margin:32px auto}@media only screen and (max-width:750px){._3xDD6kI3h9zVPQ{display:flex;margin:0 auto;flex-grow:1;width:100%;flex-direction:column}}", ""]);

// exports
exports.locals = {
	"moonshot": "_2T8-QUSnWwi13Q",
	"logo": "_8erS7cOdcGGKlg",
	"header": "FMKLJUZAMVUfoi",
	"content": "_3xDD6kI3h9zVPQ"
};